"use client";

import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import { motion, useReducedMotion } from "motion/react";
import { useTranslations } from "next-intl";

// Icônes Solar, comme partout ailleurs sur la plateforme. Variante au trait :
// ce sont des filtres, pas des accents, et un seul élément doit ressortir, celui
// qui est actif.
const categories = [
    {
        id: "all",
        icon: null,
    },
    {
        id: "developers",
        icon: "programming-linear",
    },
    {
        id: "entrepreneurs",
        icon: "case-minimalistic-linear",
    },
    {
        id: "nocode",
        icon: "bolt-linear",
    },
];

export default function ArticlesCategoryFilter({ category, onCategoryChange }) {
    const t = useTranslations();
    const reduceMotion = useReducedMotion();

    return (
        <div className="flex gap-2 flex-wrap">
            {categories.map((cat) => {
                const isActive = category === cat.id || (!category && cat.id === "all");

                return (
                    <button
                        key={cat.id}
                        onClick={() => onCategoryChange(cat.id)}
                        aria-pressed={isActive}
                        className={`
                            relative flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm
                            transition-colors duration-200 whitespace-nowrap bg-gray-100 dark:bg-grayDark-800
                            ${
                                isActive
                                    ? "text-white"
                                    : "text-gray-700 dark:text-grayDark-300 hover:bg-gray-200 dark:hover:bg-grayDark-700"
                            }
                        `}
                    >
                        {/* La pastille active glisse d'un filtre à l'autre au lieu de sauter. */}
                        {isActive && (
                            <motion.span
                                layoutId="articles-category"
                                className="absolute inset-0 rounded-xl bg-primary shadow-md shadow-primary/25"
                                transition={reduceMotion ? { duration: 0 } : { duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                            />
                        )}
                        {cat.icon && <SolarIcon name={cat.icon} className="relative w-4 h-4" />}
                        {/* « Tous les articles » a son propre libellé : celui des formations disait « Toutes les formations ». */}
                        <span className="relative">{t(cat.id === "all" ? "articles_category_all" : `courses_category_${cat.id}`)}</span>
                    </button>
                );
            })}
        </div>
    );
}
